<template>

  <Head title="Pemakai" />
  <div class="card card-outline card-primary">
    <div class="card-header">
      <h3 class="card-title">UBAH PEMAKAI</h3>
      <div class="card-tools">
        <Link href="/home" class="btn btn-tool"><i class="fas fa-times"></i></Link>
      </div>
    </div>
    <div class="card-body">
      <div class="card card-primary card-tabs">
        <div class="card-header p-0 pt-1">
          <ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="custom-tabs-one-home-tab" data-toggle="pill" href="#custom-tabs-one-home"
                role="tab" aria-controls="custom-tabs-one-home" aria-selected="true">Profile</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="custom-tabs-one-profile-tab" data-toggle="pill" href="#custom-tabs-one-profile"
                role="tab" aria-controls="custom-tabs-one-profile" aria-selected="false">Sandi</a>
            </li>
          </ul>
        </div>
        <div class="card-body">
          <div class="tab-content" id="custom-tabs-one-tabContent">
            <div class="tab-pane fade show active" id="custom-tabs-one-home" role="tabpanel"
              aria-labelledby="custom-tabs-one-home-tab">
              <form @submit.prevent="submit_profile">
                <div class="row">
                  <div class="col-sm">
                    <div class="text-center mb-3">
                      <file-pond name="imageFilepond" ref="pond" :allow-multiple="false"
                        accepted-file-types="image/png, image/jpeg" :server="{
                          url: '',
                          timeout: 7000,
                          process: {
                            url: '/upload',
                            method: 'POST',
                            headers: {
                              'X-CSRF-TOKEN': $page.props.csrf
                            },
                            withCredentials: false,
                            onload: handleFilePondLoad,
                            onerror: () => { }
                          },
                          remove: handleFilePondRemove,
                          revert: handleFilePondRevert
                        }" :files="myFiles" @init="handleFilePondInit" imagePreviewHeight="200"
                        imageResizeMode="force" imageResizeTargetWidth="220" imageResizeTargetHeight="300"
                        stylePanelLayout="compact circle" styleLoadIndicatorPosition="right bottom"
                        styleProgressIndicatorPosition="right bottom" styleButtonProcessItemPosition="right bottom"
                        styleButtonRemoveItemPosition="left bottom">
                      </file-pond>
                    </div>
                  </div>
                  <div class="col-sm">
                    <input-text label="Nama Lengkap" v-model="form.name" :error="form.errors.name" />
                    <input-text label="Email" v-model="form.email" :error="form.errors.email" readonly />
                    <input-text label="Telepon" v-model="form.phone" :error="form.errors.phone" />

                    <button type="submit" class="btn btn-primary mr-2" :disabled="form.processing">Simpan</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="tab-pane fade" id="custom-tabs-one-profile" role="tabpanel"
              aria-labelledby="custom-tabs-one-profile-tab">
              <div class="row justify-content-center">
                <div class="col-sm-6">
                  <form @submit.prevent="submit_sandi">
                    <input-text label="Sandi Lama" v-model="sandi.current_password" type="password"
                      :error="sandi.errors.current_password" />
                    <input-text label="Sandi Baru" v-model="sandi.password" type="password"
                      :error="sandi.errors.password" />
                    <input-text label="Ulangi Sandi Baru" v-model="sandi.password_confirmation" type="password"
                      :error="sandi.errors.password_confirmation" />

                    <button type="submit" class="btn btn-primary" :disabled="form.processing">Simpan</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/Master'
import { Head, Link, usePage } from '@inertiajs/vue3'
import InputText from '@/Forms/InputText'
import InputSelect2 from '@/Forms/InputSelect2'

// Import Vue FilePond
import vueFilePond, { setOptions } from 'vue-filepond';

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageCrop,
  FilePondPluginFilePoster,
);

export default {
  layout: Layout,
  components: {
    Head,
    Link,
    InputText,
    InputSelect2,
    FilePond,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.user.name,
        email: this.user.email,
        phone: this.user.phone,
        active: 1,
        image: this.user.picture,
      }),
      sandi: this.$inertia.form({
        current_password: '',
        password: '',
        password_confirmation: '',
      }),
      myFiles: [],
    }
  },
  methods: {
    submit_profile() {
      this.form.patch('/profile/'+this.user.id, {
        preserveScroll: true,
        onSuccess: page => {
          window.location.reload()
        },
        onError: errors => {
          toastr.error('Ubah profile gagal', 'GAGAL')
        },
      })
    },
    submit_sandi() {
      this.sandi.patch('/profile_sandi/'+this.user.id, {
        preserveScroll: true,
        onSuccess: page => {
          toastr.success('Ubah sandi berhasil', 'SUKSES')
        },
        onError: errors => {
          toastr.error('Ubah sandi gagal', 'GAGAL')
        },
      })
    },
    handleFilePondInit() {
      if (this.form.image) {
        this.myFiles = [{
          source: '/img/images/users/' + usePage().props.tenant + '/' + this.user.picture +'?w=200&h=200&fit=crop',
          options: {
            type: 'local',
            metadata: {
              poster: '/img/images/users/' + usePage().props.tenant + '/' + this.user.picture +'?w=200&h=200&fit=crop'
            }
          }
        }];
      } else {
        this.myFiles = [];
      }
    },
    handleFilePondLoad(response) {
      this.form.image = response;
    },
    handleFilePondRemove(source, load, error) {
      this.form.image = null;
      load();
    },
    handleFilePondRevert(uniqueId, load, error) {
      this.$inertia.post('/revert', {
        image: this.form.image
      });
      this.form.image = null;
      load();
    }
  },
}
</script>

<style>
.filepond--root {
  width: 200px;
  margin: 0 auto;
}
</style>
